<template>
  <div class="app-container">
    <Sidebar />
    <main class="main-content">
      <div class="container mx-auto p-4">
        <h1 class="text-2xl font-bold mb-4">Tiptap Editor Test</h1>
        
        <div class="alert info mb-6">
          <h3 class="font-bold">Line Break Instructions:</h3>
          <ul class="list-disc pl-5 mt-2">
            <li>Double-click anywhere in the editor to insert a line break</li>
            <li>Use the line break button (↵) in the toolbar</li>
            <li>Press Shift+Enter while typing</li>
          </ul>
        </div>
        
        <div class="mb-6">
          <QuillEditor 
            v-model="content" 
            label="Test Editor"
            placeholder="Enter some content..."
          />
        </div>
        
        <div class="mb-6">
          <QuillEditor 
            v-model="contentRtl" 
            label="RTL Test Editor"
            placeholder="أدخل بعض المحتوى..."
            dir="rtl"
          />
        </div>
        
        <div class="mt-8">
          <h2 class="text-xl font-bold mb-2">Output:</h2>
          <div class="border p-4 rounded">
            <div v-html="content"></div>
          </div>
        </div>
        
        <div class="mt-8">
          <h2 class="text-xl font-bold mb-2">RTL Output:</h2>
          <div class="border p-4 rounded">
            <div v-html="contentRtl" dir="rtl"></div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { ref } from 'vue';
import QuillEditor from '@/components/QuillEditor.vue';
import Sidebar from '@/components/Sidebar.vue';

export default {
  name: 'TestEditor',
  components: {
    QuillEditor,
    Sidebar
  },
  setup() {
    const content = ref('<p>This is a test of the new Tiptap editor. Double-click to insert a line break.</p>');
    const contentRtl = ref('<p>هذا اختبار لمحرر Tiptap الجديد. انقر نقرًا مزدوجًا لإدراج فاصل سطر.</p>');
    
    return {
      content,
      contentRtl
    };
  }
};
</script>

<style scoped>
.app-container {
  display: flex;
  min-height: 100vh;
}

.main-content {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
}

.container {
  max-width: 800px;
}

.alert {
  padding: 1rem;
  border-radius: 0.375rem;
  margin-bottom: 1rem;
}

.alert.info {
  background-color: #e0f2fe;
  border-left: 4px solid #3b82f6;
}
</style> 